export function setError(error) {
  return {
    type: 'SET_ERROR',
    error: error
  };
}
export function discardError() {
  return {
    type: 'DISCARD_ERROR'
  };
}